import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
    selector: 'app-material-details',
    templateUrl: './material-details.component.html',
    styleUrls: ['./material-details.component.scss'],
    standalone: false
})
export class MaterialDetailsComponent implements OnInit {
  material: any;
  usedOnMobile: any;
  materialId: any;
  productId: any;
  page: any;
  constructor(public dialogRef: MatDialogRef<MaterialDetailsComponent>,
              private dataService: DataService,
              public authService: AuthService,
              public utils: UtilsService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
                this.materialId = this.data.id;
                this.productId = this.data.productId;
                this.page = data.page;
              }

  ngOnInit(): void {
    if (this.page === 'company') {
      this.dataService.get('companySupportMaterial/RetrieveSupportMaterialById/' + this.materialId).then((data) => {
        if (data.statusCode === 200) {
          this.material = data.data;
        }
      });
    } else {
      let retrieveApi = '';
      if (this.page === 'training') {
        retrieveApi = 'trainingMaterial/RetrieveTrainingMaterialById/';
      } else {
        retrieveApi = 'marketingMaterial/RetrieveMarketingMaterialById/';
      }
      this.dataService.get('product/' + retrieveApi +
      this.productId + '/' + this.materialId).then((data) => {
        if (data.statusCode === 200) {
          this.material = data.data;
        }
      });
    }
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  usedOnMobileToggle(event: any) {
    this.usedOnMobile = event.source.checked;
    // used on mobile API
  }

  forceDownload(blob, filename) {
    const a = document.createElement('a');
    a.download = filename;
    a.href = blob;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  downloadResource(url: string, filename: string) {
    if (!filename) {
      filename = url.split('\\').pop().split('/').pop();
    }

    fetch(url, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/octet-stream'
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob();
    })
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob);
      this.forceDownload(blobUrl, filename);
    })
    .catch(err => {
      console.error(err);
      this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Error',
          type: 'Error',
          message: 'Something went wrong, Please try again!',
          buttonText: 'Ok'
        }
      });
    });
  }

  downloadMyFile(url: any) {
    if (url) {
      this.downloadResource(url , this.material.fileName);
    }
  }

  downloadMyFileAndLog(material: any) {
    if (!material) return;

    const isValidFile = this.isValidFileExtension(material.path);
    if (!isValidFile) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'This is a Link',
          type: 'Info',
          message: 'The selected resource is a link and cannot be downloaded directly.',
          buttonText: 'Ok'
        }
      });
      return;
    }

    this.logMaterial(material.id);

    this.downloadMyFile(material.path);
  }

  logMaterial(id: any) {
    let materialLookup
    let materialId!: number;
    this.dataService.getMaterialTypes().then((data: any) => {
      materialLookup = data;
      for (let index = 0; index < materialLookup.length; index++) {
        const element = materialLookup[index];
        if (this.page === 'training' && element.name === "ProductTrainingMaterial") {
          materialId = element.id;
        }
        else if (this.page === 'marketing' && element.name === "ProductMarketingMaterial") {
          materialId = element.id;
        }
        else if (this.page === 'company' && element.name === "CompanySupportedMaterial") {
          materialId = element.id;
        }
      }

      this.dataService.post('DownloadMaterial/DownloadProductMaterial/' + +materialId + '/' + id, null).then((data) => {
      });

    });
  }

  isValidFileExtension(filePath: string): boolean {
    const allowedExtensions = ['png', 'jpg', 'jpeg', 'txt', 'html', 'pdf', 'rtf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'];

    const fileExtension = filePath.split('.').pop()?.toLowerCase();

    return allowedExtensions.includes(fileExtension!);
  }
}
